import { render } from "./_NotFoundView.vue?vue&type=template&id=be67fb24"
const script = {}

import "./_NotFoundView.vue?vue&type=style&index=0&id=be67fb24&lang=css"

import exportComponent from "/home/runner/work/PIPIPIG233666.github.io/PIPIPIG233666.github.io/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__